import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/root/tekyerde-frontend/app/components/layout/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/root/tekyerde-frontend/app/utils/bugsnag.ts");
;
import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/globals.css");
